import { render, staticRenderFns } from "./SubRentAdd.vue?vue&type=template&id=04fec10a&scoped=true"
import script from "./SubRentAdd.vue?vue&type=script&lang=js"
export * from "./SubRentAdd.vue?vue&type=script&lang=js"
import style0 from "./SubRentAdd.vue?vue&type=style&index=0&id=04fec10a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fec10a",
  null
  
)

export default component.exports